<div *ngFor="let item of items" class="form-check form-check-inline">
    <input
      type="checkbox"
      class="form-check-input"
      [id]="item"
      [checked]="selectedItems.includes(item)"
      (change)="toggleCheckbox(item)"
    />
    <label class="form-check-label" [for]="item">{{ item }}</label>
  </div>